var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { create, liste, register } from '../../services/licence';
import { Chip } from '@mui/material';
import { Modal } from '../../utils/Modal';
import { Table } from '../../utils/Table';
import moment from 'moment';
import { IconButton } from '../../utils/IconButton';
import { LicenceIcon, VisionIcon } from '../../utils/Icons';
import { CardTitle } from '../../utils/CardTitle';
import { Drawer } from '../../utils/Drawer';
import { Error } from '../error/Error';
import { getOriginalUser } from '../../services/utilisateur';
export var Licence = function () {
    var _a = useState([]), licences = _a[0], setLicences = _a[1];
    var _b = useState(null), licenceSelected = _b[0], setLicenceSelected = _b[1];
    var originalUser = getOriginalUser();
    if (!originalUser.IsAdministrateur || !originalUser.SuperAdminKey) {
        return _jsx(Error, { status: 404 });
    }
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, liste()];
                case 1:
                    datas = _a.sent();
                    setLicences(datas);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(CardTitle, { title: "Licences", startIcon: _jsx(LicenceIcon, {}), color: "neutre", withFileAriane: true }), _jsx(Table, { isResponsive: true, canEdit: true, canAdd: true, headers: [
                    {
                        label: 'Clé',
                        assessor: 'Cle',
                    },
                    {
                        label: 'Libelle',
                        assessor: 'Libelle',
                    },
                    {
                        label: 'Schéma',
                        assessor: 'SchemaName',
                    },
                    {
                        label: 'Créée le',
                        component: function (value) {
                            return value.createdAt
                                ? moment(value.createdAt).format('DD/MM/YYYY')
                                : '-';
                        },
                    },
                    {
                        label: 'Vision',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.UseVision ? 'success' : 'default', label: value.UseVision ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Tva',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.UseTva ? 'success' : 'default', label: value.UseTva ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Document',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.UseDocument ? 'success' : 'default', label: value.UseDocument ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Actif',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.Actif ? 'success' : 'default', label: value.Actif ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Utilisateurs',
                        minWidth: true,
                        align: 'right',
                        component: function (value) { return (_jsx(IconButton, __assign({ color: "primary", tooltip: "Utilisateurs", onClick: function () { return setLicenceSelected(value); } }, { children: _jsx(VisionIcon, {}) }))); },
                    },
                ], datas: licences ? licences : [], renderModalEdition: function (handleClose) {
                    return (_jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Ajouter licence" }, { children: _jsx(FormikGenerator, { submitLabel: "Ajouter", datas: {}, onSubmit: function (values, _a) {
                                var resetForm = _a.resetForm;
                                return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0: return [4 /*yield*/, create(values)];
                                            case 1:
                                                _b.sent();
                                                resetForm();
                                                handleClose();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }, fields: [
                                [
                                    {
                                        name: 'Actif',
                                        label: 'Actif',
                                        type: TYPES.BOOLEAN,
                                        xs: 3,
                                    },
                                    {
                                        name: 'UseVision',
                                        label: 'Vision',
                                        type: TYPES.BOOLEAN,
                                        xs: 3,
                                    },
                                    {
                                        name: 'UseTva',
                                        label: 'Tva',
                                        type: TYPES.BOOLEAN,
                                        xs: 3,
                                    },
                                    {
                                        name: 'UseDocument',
                                        label: 'Document',
                                        type: TYPES.BOOLEAN,
                                        xs: 3,
                                    },
                                    {
                                        name: 'Cle',
                                        label: 'Société',
                                        type: TYPES.TEXT,
                                    },
                                    {
                                        name: 'SchemaName',
                                        label: 'Schéma',
                                        type: TYPES.TEXT,
                                    },
                                    {
                                        name: 'Libelle',
                                        label: 'Libelle',
                                        type: TYPES.TEXT,
                                    },
                                ],
                            ] }) })));
                }, refresh: getData }), licenceSelected && (_jsx(Drawer, __assign({ title: licenceSelected.Libelle, startIcon: _jsx(LicenceIcon, {}), onClose: function () { return setLicenceSelected(null); } }, { children: _jsx(Table, { isResponsive: true, canAdd: true, canEdit: true, headers: [
                        {
                            label: 'Login',
                            assessor: 'Login',
                        },
                        {
                            label: 'Nom',
                            assessor: 'Nom',
                        },
                        {
                            label: 'Prenom',
                            assessor: 'Prenom',
                        },
                        {
                            label: 'Email',
                            assessor: 'Email',
                        },
                        {
                            label: 'Telephone',
                            assessor: 'Telephone',
                        },
                        {
                            label: 'Mobile',
                            assessor: 'Mobile',
                        },
                        {
                            label: 'Mobile',
                            assessor: 'Mobile',
                        },
                        {
                            label: 'Créé le',
                            component: function (value) {
                                return value.createdAt
                                    ? moment(value.createdAt).format('DD/MM/YYYY')
                                    : '-';
                            },
                        },
                        {
                            label: 'Connecté le',
                            component: function (value) {
                                return value.DateDerniereConnexion
                                    ? moment(value.DateDerniereConnexion).format('DD/MM/YYYY')
                                    : '-';
                            },
                        },
                        {
                            label: 'Mot de passe',
                            minWidth: true,
                            component: function (value) { return (_jsx(Chip, { color: value.ForceResetPassword ? 'success' : 'default', label: value.ForceResetPassword ? 'À réinitialiser' : 'OK' })); },
                        },
                        {
                            label: 'Collab.',
                            minWidth: true,
                            component: function (value) { return (_jsx(Chip, { color: value.CollaborateurId ? 'success' : 'default', label: value.CollaborateurId ? 'Avec' : 'Sans' })); },
                        },
                        {
                            label: 'Administrateur',
                            minWidth: true,
                            component: function (value) { return (_jsx(Chip, { color: value.Administrateur ? 'success' : 'default', label: value.Administrateur ? 'Oui' : 'Non' })); },
                        },
                        {
                            label: 'Actif',
                            minWidth: true,
                            component: function (value) { return (_jsx(Chip, { color: value.Actif ? 'success' : 'default', label: value.Actif ? 'Oui' : 'Non' })); },
                        },
                    ], datas: licenceSelected.Utilisateurs ? licenceSelected.Utilisateurs : [], renderModalEdition: function (handleClose) {
                        return (_jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Ajouter utilisateur" }, { children: _jsx(FormikGenerator, { submitLabel: "Ajouter", datas: {}, onSubmit: function (values, _a) {
                                    var resetForm = _a.resetForm;
                                    return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0: return [4 /*yield*/, register(values)];
                                                case 1:
                                                    _b.sent();
                                                    resetForm();
                                                    handleClose();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    });
                                }, fields: [
                                    [
                                        {
                                            name: 'SendEmail',
                                            label: 'Envoyer email',
                                            type: TYPES.BOOLEAN,
                                        },
                                        {
                                            name: 'IsAdministrateur',
                                            label: 'Administrateur',
                                            type: TYPES.BOOLEAN,
                                        },
                                        {
                                            name: 'Societe',
                                            label: 'Société',
                                            type: TYPES.TEXT,
                                        },
                                        {
                                            name: 'Login',
                                            label: 'Login',
                                            type: TYPES.TEXT,
                                        },
                                        {
                                            name: 'Email',
                                            label: 'Email',
                                            type: TYPES.TEXT,
                                        },
                                        {
                                            name: 'Nom',
                                            label: 'Nom',
                                            type: TYPES.TEXT,
                                        },
                                        {
                                            name: 'Prenom',
                                            label: 'Prenom',
                                            type: TYPES.TEXT,
                                        },
                                    ],
                                ] }) })));
                    } }) })))] }));
};
//# sourceMappingURL=Licence.js.map